"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
exports.isFontWithoutValue = function (font) {
    if (font.value) {
        return false;
    }
    var family = font.family || font.cssFontFamily;
    return !!family;
};
var defaultFontStyle = {
    bold: false,
    italic: false,
    underline: false,
};
exports.calculateFont = function (font) {
    var fontStyle = font.style || defaultFontStyle;
    var family = font.family || font.cssFontFamily;
    var style = fontStyle.italic ? 'italic' : 'normal';
    var variant = 'normal';
    var weight = fontStyle.bold ? 'bold' : 'normal';
    var lineHeight = '1.4em';
    var size = font.size || 'normal';
    if (_.isNumber(size)) {
        size = size + "px";
    }
    return "font: " + style + " " + variant + " " + weight + " " + size + "/" + lineHeight + " " + family + ";";
};
//# sourceMappingURL=font.js.map